import React from 'react';
import { StyledPauseLabel } from './styles/StyledPauseLabel';

const PausedLabel = () => (
    <StyledPauseLabel>Paused</StyledPauseLabel>
);

export default PausedLabel;